/* eslint-disable */
import {
  Grid,
  RACCard,
  Divider,
  RACModal,
  RACButton,
  Typography,
} from '@rentacenter/racstrap';

import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useShopLocalData } from './ShopLocalProvider';
import { ReactComponent as ProcessSpinner } from '../../../assets/images/Spinner.svg';
import { ReactComponent as ProcessSuccess } from '../../../assets/images/validation-success.svg';
import { ReactComponent as ProcessFailed } from '../../../assets/images/warningIcon.svg';
import { ReactComponent as InfoIconBlue } from '../../../assets/images/info-icon-blue.svg';
import { determineProductLeasability, prefundCard } from '../../../api/user';
import { FundingProductInfo, PrefundCardDTO } from '../../../types/types';
import { localSourcingStatusModalStyles } from '../../../JSstyles/localSourcingStatusModalStyles';

export interface ModalProps {
  onClose: (onclose: boolean | undefined) => void;
  finalizeShopLocal: () => void;
}

const STATUS_LEASABILITY = 'Determining if the product is leasable ...';
const STATUS_PREFUNDING = 'Obtaining the necessary funding for the card ...';
const STATUS_APPROVAL = 'Approval Successful!';
const STATUS_FAILURE = 'Unable to Prefund the Card';
const PROBLEM_NOT_LEASABLE =
  'Item is not leasable.  Try updating the description.';
const PROBLEM_NO_FUNDING =
  'Unable to secure funding with the credit card company!  Please contact support.';

export const ShopLocalStatusModal = ({
  onClose,
  finalizeShopLocal,
}: ModalProps) => {
  const classes = localSourcingStatusModalStyles();
  const { t } = useTranslation();

  const [acquirePrefunding, setAcquirePrefunding] = useState<boolean>(false);
  const [blinkIt, setBlinkIt] = useState<boolean>(false);
  const [processing, setProcessing] = useState<boolean>(false);
  const [processSuccess, setProcessSuccess] = useState<boolean>(false);
  const [processFailed, setProcessFailed] = useState<boolean>(false);
  const [processConditional, setProcessConditional] = useState<boolean>(false);
  const leasable = useRef<boolean>();
  const conditionalMessage = useRef<string>();

  const { totalCost, vendorName, products, estimatedWeeklyPayment, estimatedWeeklyTerm } = useShopLocalData();

  const [statusmsg, setStatusMsg] = useState<string>();
  const [errmsg, setErrMsg] = useState<string>();
  const toggle = useRef<boolean>(false);

  const invokeAcquire = async () => {
    const productList : FundingProductInfo[] = 
    products.map( (one) => { return {
      modelNumber: `${one.rmsInfo.rmsItemNumber}`,
      amount: one.unitCost,
      quantity: one.quantity,
      itemNumber:  `${one.rmsInfo.rmsItemNumber}`,
      weeklyRate: one.weeklyRate,
      cashPrice: one.cashPrice,
      totalCost: one.totalCost,
      weeklyTerm: `${one.weeklyTerm}`
    } } );

    // Read from router state passed by Trailblazers team
    const locationState: any = (window.history.state as any)?.usr || (window.history.state as any)?.state || {};
    const empId = locationState.employeeId || window.sessionStorage.getItem('employeeId') || '';
    const approvalLvl = locationState.approvalLevel || '1';
    const globalCustId = locationState.globalCustomerId || window.sessionStorage.getItem('globalCustomerId') || '';

    const payload : PrefundCardDTO = {
      totalFundingAmount: totalCost,
      storeNumber: window.sessionStorage.getItem( 'storeNumber') || '03770',
      employeeId: empId,
      approvalLevel: approvalLvl,
      vendorName: vendorName,
      globalCustomerId: globalCustId,
      spendOrigin: 'SLOC',
      products: productList
    }; 

    await prefundCard(payload)
      .then((out) => {
        setErrMsg('');
        if (out.status == 200) {
          setStatusMsg(STATUS_APPROVAL);
          setProcessing(false);
          setProcessSuccess(true);
          setProcessFailed(false);
          setProcessConditional(false);
        } else {
          setStatusMsg(STATUS_FAILURE);
          leasable.current = false;
          setErrMsg(PROBLEM_NO_FUNDING);
          setProcessing(false);
          setProcessSuccess(false);
          setProcessConditional(false);
          setProcessFailed(true);
        }
      })
      .catch((err) => {
        setStatusMsg(PROBLEM_NO_FUNDING);
        setErrMsg(err);
      });
  };
  useEffect(() => {
    const invoke = async () => {
      await invokeAcquire();
      setAcquirePrefunding(false);
    };
    if (acquirePrefunding) {
      invoke();
    }
  }, [acquirePrefunding]);

  useEffect(() => {
    setInterval(() => {
      toggle.current = !toggle.current;
      setBlinkIt(toggle.current);
    }, 750);
    setErrMsg('');
    setStatusMsg(STATUS_LEASABILITY);
    setProcessing(true);
    setProcessSuccess(false);
    setProcessConditional(false);
    setProcessFailed(false);

    const step1 = async () => {
      const itemsToSend: any[] = [];
      products.forEach((oneProduct) => {
        const priceToSet =
          Number(oneProduct.quantity) * Number(oneProduct.unitCost);
        const one = {
          description: oneProduct.productName,
          price: `${priceToSet}`,
          quantity: Number(oneProduct.quantity),
          wholesale: true,
        };
        itemsToSend.push(one);
      });

      const payload = {
        subTotal: totalCost,
        salesTax: '0',
        total: totalCost,
        shipping: '0',
        discounts: '0',
        inventoryItems: itemsToSend,
      };

      //todo:  this must cycle through all items and respond back for each item
      //       leading to a possible conditional approval
      await determineProductLeasability(payload)
        .then((out) => {
          if (out.status == 200 && out.data) {
            determineLeaseStatusForAllItems(out.data);            
          } else {
            setStatusMsg(PROBLEM_NOT_LEASABLE);
            setErrMsg(`Unknown error encountered!  ${out.statusText}`);
            setProcessing(false);
            setProcessSuccess(false);
            setProcessConditional(false);
            setProcessFailed(true);
          }
        })
        .catch((err) => {
          setStatusMsg(PROBLEM_NOT_LEASABLE);
          setErrMsg(err);
        });
    };

    step1();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const determineLeaseStatusForAllItems = (serviceOutput: any): void => {
    leasable.current = true;
    let oneGoodProduct : boolean = false;
    let leasabilityResponse;
    let completeStatusMsg = '';
    if ( Array.isArray(serviceOutput) ) {
      leasabilityResponse = serviceOutput[0];
    } else {
      leasabilityResponse = serviceOutput;
    }

    products.forEach((oneProduct) => {
      leasabilityResponse.items.forEach((item) => {
        if (item.leaseable != '1') {
          leasable.current = false; // any of them not leasable take note
        }

        if (oneProduct.productName == item.description) {
          if (item.leaseable == '1') {
            oneProduct.leasable = true;
            oneGoodProduct = true;
            oneProduct.errorMsg = '';
          } else {
            oneProduct.leasable = false;
            oneProduct.errorMsg = item.reason;
          }
        }
      });
     
      if ( !oneProduct.leasable ) {
        completeStatusMsg = completeStatusMsg + `${oneProduct.productName} : ${oneProduct.errorMsg} `
      }
    });
    
    conditionalMessage.current = completeStatusMsg;
    
    if (completeStatusMsg === '' ) {
      setStatusMsg(STATUS_PREFUNDING);
      setErrMsg('');
      setAcquirePrefunding(true);
    } else {
      setProcessing(false);
      setProcessSuccess(false);
      setProcessConditional(oneGoodProduct);
      setProcessFailed(!oneGoodProduct);      
      setStatusMsg('Changes Required!  ');
      setErrMsg(completeStatusMsg);
    
    }
  };


  return (
    <RACModal
      isOpen
      classes={{
        dialogContent: classes.dialogContent,
        dialogActions: classes.dialogActions,
        dialog: classes.dialogRoot,
        dialogTitle: classes.dialogTitle,
      }}
      title=""
      maxWidth="lg"
      content={
        <>
          <Grid container classes={{ root: classes.containerStyle }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              {processing && (
                <ProcessSpinner className={clsx(classes.spinnerstyle)} />
              )}
              {processSuccess && (
                <ProcessSuccess className={clsx(classes.successstyle)} />
              )}
              {(processFailed || processConditional) && (
                <ProcessFailed className={clsx(classes.successstyle)} />
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography classes={{ root: classes.StatusHeader }}>
                {processing && 'Processing Prefund Request'}
                {processSuccess && 'Approval Successful!'}
                {processConditional && 'Some Ineligible Item(s)  - Changes Required'}
                {processFailed && 'All Item(s) are Ineligible - Changes Required'}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              classes={{ root: classes.grid }}
            >
              <Typography className={clsx(classes.InfoHeader)}>
                {processing &&
                  'Communicating with the funding partner to secure your approval.  Please do not close this screen.'}
                {processSuccess &&
                  `Your prefund request has been approved.  Please proceed to complete your checkout at  ${vendorName}`}
                {processConditional && conditionalMessage.current}
                {processFailed &&
                  'Your prefund request needs changes.  Please take note of the error message and make applicable changes.'}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              classes={{ root: classes.grid }}
            >
              <Typography className={clsx(classes.InfoHeader)}>
                {' '}
              </Typography>
            </Grid>
          </Grid>

          
<RACCard className={clsx(classes.card)}>
                <div className={clsx(classes.cardBody)}>
                  <Grid container classes={{ root: classes.answergrid }}>
                    <Grid
                      item
                      xs={5}
                      sm={5}
                      md={5}
                      lg={5}
                      classes={{ root: classes.answergrid }}
                    >
                      <Typography className={clsx(classes.label)}>
                        {`Total Financing Request for   ${vendorName}`}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      sm={2}
                      md={2}
                      lg={2}
                      classes={{ root: classes.divideStyle }}
                    >
                      <Divider
                        style={{ width: 4 }}
                        orientation="vertical"
                      ></Divider>
                    </Grid>
                    <Grid
                      item
                      xs={5}
                      sm={5}
                      md={5}
                      lg={5}
                      classes={{ root: classes.answergrid }}
                    >
                      <Typography className={clsx(classes.label)}>
                        {'Estimated Weekly Payment'}{' '}
                      </Typography>
                    </Grid>

                    <Grid
                      item
                      xs={5}
                      sm={5}
                      md={5}
                      lg={5}
                      classes={{ root: classes.answergrid }}
                    >
                      <Typography className={clsx(classes.label)}>
                        {totalCost}{' '}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      sm={2}
                      md={2}
                      lg={2}
                      classes={{ root: classes.divideStyle }}
                    >
                      <Divider
                        style={{ width: 4 }}
                        orientation="vertical"
                      ></Divider>
                    </Grid>
                    <Grid
                      item
                      xs={5}
                      sm={5}
                      md={5}
                      lg={5}
                      classes={{ root: classes.answergrid }}
                    >
                      <Typography className={clsx(classes.label)}>
                        {estimatedWeeklyPayment}{' '}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={5}
                      sm={5}
                      md={5}
                      lg={5}
                      classes={{ root: classes.answergrid }}
                    >
                      <Typography className={clsx(classes.label)}>
                        {'( +tax )'}{' '}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      sm={2}
                      md={2}
                      lg={2}
                      classes={{ root: classes.divideStyle }}
                    >
                      <Divider
                        style={{ width: 4 }}
                        orientation="vertical"
                      ></Divider>
                    </Grid>
                    <Grid
                      item
                      xs={5}
                      sm={5}
                      md={5}
                      lg={5}
                      classes={{ root: classes.answergrid }}
                    >
                      <Typography className={clsx(classes.label)}>
                        {'( +tax )'}{' '}
                      </Typography>
                    </Grid>
                  </Grid>
                </div>
              </RACCard>

          {processSuccess && (
            <Grid container classes={{ root: classes.containerStyle }}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                classes={{ root: classes.taxexemptstyle }}
              >
                <InfoIconBlue className={classes.infoIcon} />
                <Typography className={clsx(classes.InfoHeader)}>
                  {
                    'Please Note:  You will be required to upload tax-exempt documentation during the checkout process.'
                  }
                </Typography>
              </Grid>
            </Grid>
          )}
        </>
      }
      onClose={() => onClose(leasable.current)}
      buttons={
        <>
          <Grid container className={clsx(classes.buttonContainerStyle)}>
            <Grid item xs={8} sm={8} md={8} lg={8}>
              {blinkIt && (
                <Typography className={clsx(classes.statusstyle)}>
                  {statusmsg}
                </Typography>
              )}
              {errmsg && (
                <Typography className={clsx(classes.errorstyle)}>
                  {errmsg}
                </Typography>
              )}
            </Grid>
            {(processFailed || processSuccess || processConditional) && (
              <Grid item xs={4} sm={4} md={4} lg={4}>
                <RACButton
                  // eslint-disable-next-line
                  // @ts-ignore
                  variant="outlined"
                  color="secondary"
                  onClick={() => onClose(!leasable.current)}
                  disabled={false}
                >
                  {t('Cancel')}
                </RACButton>
                <RACButton
                  // eslint-disable-next-line
                  // @ts-ignore
                  variant="contained"
                  color="primary"
                  onClick={() => finalizeShopLocal()}
                  // disabled={!continueEnabled}
                >
                  {t('finish')}
                </RACButton>
              </Grid>
            )}
          </Grid>
        </>
      }
    />
  );
};
